(function () {
  if (window.__warroadGtmAnalyticsBound) return;
  window.__warroadGtmAnalyticsBound = true;

  if (!window.__warroadAddToCartDedupe) {
    window.__warroadAddToCartDedupe = (function () {
      const recent = [];
      const TTL_MS = 3000;

      function getKey(payload) {
        if (!payload || payload.event !== 'add_to_cart') return null;

        const items = payload.ecommerce?.items;
        if (!Array.isArray(items) || items.length === 0) return null;

        return items
          .map((item) => `${item.item_id || ''}:${item.quantity || 1}`)
          .sort()
          .join('|');
      }

      function prune() {
        const now = Date.now();
        for (let index = recent.length - 1; index >= 0; index -= 1) {
          if (now - recent[index].ts >= TTL_MS) {
            recent.splice(index, 1);
          }
        }
      }

      return {
        allowPayload(payload) {
          const key = getKey(payload);
          if (!key) return true;

          prune();

          if (recent.some((entry) => entry.key === key)) {
            return false;
          }

          recent.push({ key, ts: Date.now() });
          return true;
        },
      };
    })();
  }

  function getRequestQuantity(requestBody) {
    if (!requestBody) return 1;

    if (requestBody instanceof FormData || requestBody instanceof URLSearchParams) {
      const quantity = Number(requestBody.get('quantity'));
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    }

    if (Array.isArray(requestBody.items) && requestBody.items.length > 0) {
      return requestBody.items.reduce((sum, item) => sum + (Number(item.quantity) || 1), 0);
    }

    const quantity = Number(requestBody.quantity);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function getRequestVariantIds(requestBody) {
    if (!requestBody) return [];

    if (requestBody instanceof FormData || requestBody instanceof URLSearchParams) {
      const variantId = requestBody.get('id');
      if (!variantId) return [];

      return [{ id: String(variantId), quantity: getRequestQuantity(requestBody) }];
    }

    if (Array.isArray(requestBody.items) && requestBody.items.length > 0) {
      return requestBody.items.map((item) => ({
        id: String(item.id),
        quantity: Number(item.quantity) > 0 ? Number(item.quantity) : 1,
      }));
    }

    if (requestBody.id) {
      return [{ id: String(requestBody.id), quantity: getRequestQuantity(requestBody) }];
    }

    return [];
  }

  function buildEcommerceItem(cartItem, quantity) {
    const unitPrice = (cartItem.price || 0) / 100;

    return {
      item_id: cartItem.sku || String(cartItem.variant_id || cartItem.id || ''),
      item_name: cartItem.product_title || cartItem.title || '',
      item_variant: cartItem.variant_title && cartItem.variant_title !== 'Default Title'
        ? cartItem.variant_title
        : '',
      price: unitPrice,
      quantity: quantity || cartItem.quantity || 1,
    };
  }

  function pushAddToCartEvent(items, currency) {
    if (!items.length) return;

    window.dataLayer = window.dataLayer || [];

    const payload = {
      event: 'add_to_cart',
      ecommerce: {
        currency: currency || 'USD',
        value: items.reduce((sum, item) => sum + item.price * item.quantity, 0),
        items,
      },
    };

    if (!window.__warroadAddToCartDedupe.allowPayload(payload)) {
      return;
    }

    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(payload);
  }

  function getAddedItemsFromCartDiff(cart, previousCart, requestedVariants) {
    if (!cart?.items?.length || !requestedVariants.length) return [];

    return requestedVariants
      .map((requestedVariant) => {
        const variantId = Number(requestedVariant.id);
        const cartItem = cart.items.find(
          (item) => item.variant_id === variantId || item.id === variantId
        );

        if (!cartItem) return null;

        let addedQuantity = requestedVariant.quantity;

        if (previousCart?.items?.length) {
          const previousItem = previousCart.items.find(
            (item) => item.variant_id === variantId || item.id === variantId
          );

          if (previousItem) {
            addedQuantity = Math.max(
              cartItem.quantity - previousItem.quantity,
              requestedVariant.quantity
            );
          }
        }

        return buildEcommerceItem(cartItem, addedQuantity);
      })
      .filter(Boolean);
  }

  function trackQuickAddModalCartAdd(requestState, cart, previousCart) {
    const responseBody = requestState?.responseData?.body;
    const currency = cart?.currency || responseBody?.currency;

    if (
      Array.isArray(responseBody?.items) &&
      responseBody.items.length > 0 &&
      !responseBody.token
    ) {
      const items = responseBody.items.map((item) => buildEcommerceItem(item, item.quantity));
      pushAddToCartEvent(items, currency);
      return;
    }

    const requestedVariants = getRequestVariantIds(requestState?.requestBody);
    const items = getAddedItemsFromCartDiff(cart, previousCart, requestedVariants);
    pushAddToCartEvent(items, currency);
  }

  window.__warroadTrackQuickAddCart = trackQuickAddModalCartAdd;

  document.addEventListener('liquid-ajax-cart:request-end', (event) => {
    const { requestState, cart, previousCart } = event.detail || {};

    if (!requestState || requestState.requestType !== 'add' || !requestState.responseData?.ok) {
      return;
    }

    trackQuickAddModalCartAdd(requestState, cart, previousCart);
  });

  document.addEventListener('quick-add-modal:added-to-cart', (event) => {
    const { requestState, cart, previousCart } = event.detail || {};

    if (!requestState || requestState.requestType !== 'add' || !requestState.responseData?.ok) {
      return;
    }

    trackQuickAddModalCartAdd(requestState, cart, previousCart);
  });
})();
